import type {
  AttributesStatus,
  AttributeTaskStatus,
  LinesheetStatus,
  PriceStatus,
  ProductStatus,
  StyleMarginIssue,
  SyncRunStatus,
  SyncStatus,
} from "@nexxt/contracts/catalog";
import type { Tone } from "./tone";

// Tone of every catalog state (design-system.md §2.3): a new enum value does not compile until it has one.

export const linesheetStatusTone: Record<LinesheetStatus, Tone> = {
  draft: "neutral",
  pending: "warning",
  approved: "success",
};

export const priceStatusTone: Record<PriceStatus, Tone> = {
  pending: "warning",
  approved: "success",
};

export const syncStatusTone: Record<SyncStatus, Tone> = {
  not_synced: "neutral",
  sync_in_progress: "info",
  sync_failed: "danger",
  sync_complete: "success",
};

export const syncRunStatusTone: Record<SyncRunStatus, Tone> = {
  queued: "neutral",
  sent: "info",
  awaiting_callback: "info",
  succeeded: "success",
  failed: "danger",
};

export const productStatusTone: Record<ProductStatus, Tone> = {
  draft: "neutral",
  active: "success",
  discontinued: "neutral",
};

export const attributeTaskStatusTone: Record<AttributeTaskStatus, Tone> = {
  open: "neutral",
  in_progress: "info",
  complete: "success",
  overdue: "danger",
};

export const attributesStatusTone: Record<AttributesStatus, Tone> = {
  draft: "neutral",
  pending: "warning",
  sync_in_progress: "info",
  approved: "success",
};

/** What a style's margin misses (B-59, ADR-215): a missing rate is Finance's to fix, the rest says what did not happen. */
export const styleMarginIssueTone: Record<StyleMarginIssue, Tone> = {
  no_price_setup: "warning",
  no_estimate: "warning",
  no_sales: "neutral",
  no_purchase: "neutral",
  missing_rate: "danger",
};
